<template>
    <v-dialog v-model="dialog" max-width="700" scrollable>
        <v-card class="container">
            <v-card-title class="pa-0">
                <v-row
                    no-gutters
                    class="standard-row header-text"
                    justify="space-between"
                >
                    <span>
                        ยกเลิกรายการที่บันทึก
                    </span>
                    <span>
                        Value : {{ externalData.total_actual }}
                    </span>
                </v-row>
            </v-card-title>
            <v-card-text class="main-body-container">
                <v-row
                    no-gutters
                    justify="center"
                    class="standard-row"
                >
                    <v-data-table
                        :headers="headers"
                        :items="externalData.cs_list"
                        :hide-default-header="$vuetify.breakpoint.smAndUp && true"
                        :hide-default-footer="true"
                        disable-sort
                        class="elevation-0 data-table"
                    ></v-data-table>
                </v-row>
            </v-card-text>
            <v-card-actions class="pt-12 px-0 pb-0">
                <v-row
                    no-gutters
                    align="center"
                    class="standard-row action-row-container"
                >
                    <span class="info-text">*เมื่อยกเลิกรายการจะกลับสู่หน้าสร้างเอกสาร ในกรณีบันทึกงบประมาณจะคืน งบประมาณเสมอ</span>
                    <v-btn
                        color="#D8D8D8"
                        depressed
                        elevation="0"
                        height="30"
                        class="confirm-button"
                        :loading="loadingConfirmBtn"
                        @click="confirmDelete(externalData._id)"
                    >
                        <v-icon size="20" class="mr-2" color="#848484">
                            mdi-delete
                        </v-icon>
                        ยืนยัน
                    </v-btn>
                </v-row>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { EventBus } from '../EventBus';
import { MainFunction } from '@/functions/mainFunction.js';
    export default {
        data: () => ({
            dialog: false,
            externalData: {},
            headers: [
                { text: 'No.', value: 'no' },
                { text: 'Sale Document', value: 'sale_document' },
                { text: 'Document ID', value: 'document_id' },
                { text: 'Group Service', value: 'group_service' },
                { text: 'Actual', value: 'actual' },
                { text: 'Revenue', value: 'revenue' }
            ],
            loadingConfirmBtn: false
        }),
        mounted () {
            EventBus.$on('openSaveBudgetListModal', this.openDialog);
        },
        beforeDestroy () {
            EventBus.$off('openSaveBudgetListModal');
        },
        methods: {
            openDialog(data) {
                this.externalData = {
                    "_id": data.transaction_id,
                    "total_actual": 0,
                    "cs_list": data.expanded.map((e, i) => {
                        return {
                            "no": i + 1,
                            "sale_document": e.cs_list[0].sale_document,
                            "document_id": e.cs_list[0].document_id,
                            "group_service": e.cs_list[0].group_service,
                            "actual": e.cs_list[0].actual,
                            "revenue": e.cs_list[0].revenue
                        };
                    })
                };
                this.externalData.total_actual = MainFunction.addComma(this.externalData.cs_list.reduce((acc, prev) => {
                    const actual = +(prev.actual?.replace(/,/g, '') || '0');
                    return acc + (isNaN(actual) ? 0 : actual);
                }, 0));
                this.dialog = true;
            },
            async confirmDelete(id) {
                this.loadingConfirmBtn = true
                try {
                    const { data } = await this.axios.put(`${this.$api_url}/cs_to_po/api/v1/cancel_cs_to_po/${id || ''}`)
                    if (data.status) {
                        this.dialog = false;
                        this.alert('ยกเลิกรายการที่บันทึกสำเร็จ', 'Success', 'success');
                        EventBus.$emit('afterOpenSaveBudgetListModal');
                    }
                } catch (error) {
                    console.log(error)
                    this.alert('ยกเลิกรายการที่บันทึกไม่สำเร็จ', 'Fail', 'error')
                } finally {
                    this.loadingConfirmBtn = false
                }
            },
            alert(title = '', text = '', icon = 'info') {
                this.$swal({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    icon: icon,
                    title: `<b class="alert-success-title">${title}</b>`,
                    text:  text,
                    showClass: {
                        popup: 'animate-show-card'
                    },
                    customClass: {
                        container: 'alert-card-block',
                        popup: 'alert-card-success',
                        title: 'alert-title-block',
                        htmlContainer: 'alert-text-box',
                        icon: 'alert-icon'
                    }
                });
            },
        }
    }
</script>

<style scoped>

    .container {
        font-family: 'Noto Sans Thai', sans-serif;
        border-radius: 10px;
        padding: 18px 14px;
        color: #000;
    }

    .header-text {
        font-size: 14px;
        font-weight: 700;
    }

    .main-body-container {
        width: 100%;
        overflow: auto;
        padding: 20px 0 0 0 !important;
    }

    .action-row-container {
        justify-content: space-between;
    }

    .info-text {
        color: #B61414;
        font-size: 10px;
        font-weight: 400;
    }

    .confirm-button {
        color: #000;
        font-size: 15px;
        font-weight: 500;
        border-radius: 5px;
    }

    .data-table {
        width: 100%;
    }

    .data-table >>> .v-data-table__wrapper > table > tbody > tr {
        pointer-events: none;
    }

    .data-table >>> .v-data-table__wrapper > table > tbody > tr > td {
        height: 30px;
        border-bottom: none !important;
        font-size: 10px !important;
        font-weight: 400;
    }

    @media only screen and (max-width: 37.5em) {

        .action-row-container {
            justify-content: center;
        }

        .info-text {
            text-align: center;
            flex: 0 0 100%;
            padding-bottom: 16px;
        }

        .main-body-container {
            padding: 0 !important;
        }

        .data-table >>> .v-data-table__wrapper .v-data-table__mobile-table-row:nth-child(even) {
            background-color: #F1F1F1 !important;
        }

        .data-table >>> .v-data-table__wrapper .v-data-table__mobile-row {
            min-height: 30px;
        }
    }
</style>